import OnBoardingContainer from "@/components/OnboardingContainer"
import ChangePasswordForm from "./components/ChangePasswordForm"


const ChangePassword = () => {
  return (
    <OnBoardingContainer>
      <ChangePasswordForm />
    </OnBoardingContainer>
  )
}

export default ChangePassword